import React, { useContext, useState } from 'react'
import { Grid, ListItemIcon, Menu, MenuItem, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { WorkflowContext, WorkflowContextPayload, workflowList } from '../../../context/workflowContext';

import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import workflowStyle from "../../../assets/styles/componentStyles/workflowStyles/workflowStyle.module.scss"; 
import workFlowGlobalStyles from '../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss'
import globalStyles from "../../../assets/styles/global.module.scss";

import MoreVertIcon from '@mui/icons-material/MoreVert';
import whatsappIcon from '../../../assets/Whatsapp.svg'
import instagramIcon from '../../../assets/images/channels/instagram/instagram.png'

import IconsColor from '../../utility/iconsColor';
import GlobalTooltip from '../../utility/tooltip/globalTooltip';
import QRimage from '../../../assets/chatbotAssets/QRimage.png'
import { getChatbotListNewReponseModel } from '../../../models/axiosModel';
import { useNavigate } from 'react-router-dom';
import { onClickOfQRCode } from '../flowBuilder/flowBuilderConstants';
import { CHATBOT_CHANNEL_NAME } from '../../../pages/ruleBasedInbox/channelConstants';
import { GENERIC_STATUS, getValueOrDefault } from '../../../utils/constants';
import { primaryColor } from '../../../utils/colors';

interface WorkflowTableProps {
    innerHeight: number,
    filteredWorkFlowList: getChatbotListNewReponseModel[] | null,
    setFilteredWorkFlowList: React.Dispatch<React.SetStateAction<getChatbotListNewReponseModel[] | null>>,
    anchorEl: HTMLElement | null,
    setAnchorEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>,
    currentRowIndex: number | string | null,
    setCurrentRowIndex: React.Dispatch<React.SetStateAction<string | number | null>>,
    handleMenuOpen: (event: React.MouseEvent<HTMLElement, MouseEvent>, rowIndex: number | string, list: any) => void,
    handleMenuClose: () => void,
    setFlagDeleteWorkflowPopup: React.Dispatch<React.SetStateAction<boolean>>, 
    workflowActionMenuItem: {
        label: string;
        icon: JSX.Element;
        action: (list: any) => void; 
        isDisabled: boolean;
    }[],
}
export interface sortConfig {
    key: string,
    direction: string,
}

const WorkflowTable: React.FC<WorkflowTableProps> = (props) => {
    
    const { innerHeight, filteredWorkFlowList, setFilteredWorkFlowList, anchorEl, setAnchorEl, currentRowIndex, setCurrentRowIndex, handleMenuOpen, handleMenuClose, setFlagDeleteWorkflowPopup, workflowActionMenuItem } = props;

    const { setFlagShowQRCodePopup, setPhoneNumberQR, setConditionGroup, setQrChannelName } = useContext(WorkflowContext) as WorkflowContextPayload;

    const [sortConfig, setSortConfig] = useState<sortConfig>({ key: "", direction: '' });
    const [changeField, setChangeField] = useState("");
    const navigate = useNavigate()

    const getChatbotStatusName = (list: getChatbotListNewReponseModel) => {
        return getValueOrDefault(list?.chatbot_status?.chatbot_status_name);
    }
    const getChatbotImportStatusName = (list: getChatbotListNewReponseModel) => {
        return getValueOrDefault(list?.import_status?.import_status_name);
    }

    const isImportStatusImporting = (list: getChatbotListNewReponseModel) => {
        return getChatbotImportStatusName(list)?.toLowerCase() === GENERIC_STATUS.IMPORTING?.toLowerCase();
    }
    const isImportStatusFailed = (list: getChatbotListNewReponseModel) => {
        return getChatbotImportStatusName(list)?.toLowerCase() === GENERIC_STATUS.FAILED?.toLowerCase();
    }

    const handleDotColor = (list: getChatbotListNewReponseModel) => {
        if (isImportStatusImporting(list)) return "rgba(142, 68, 173, 1)";
        if (isImportStatusFailed(list)) return "rgb(255, 0, 0, 1)";

        switch (list.chatbot_status.chatbot_status_name.toLowerCase()) {
            case "paused":
                return "rgba(226, 162, 42, 1)";
            case "active":
                return "rgba(15, 185, 21, 1)";
            default:
                return "rgba(42, 165, 226, 1)";
        }
    }

    const handleIntegratedChannel = (channelName: string) => {
        switch (channelName.toLowerCase()) {
            case "whatsapp":
                return <img alt="whatsApp" src={whatsappIcon} height={"22"} width={"22"} style={{ display: "flex" }} />
            case "facebook":
                return <IconsColor iconName="facebook_messenger" width="21px" height="21px" />
            case "instagram":
                return <img alt="instagram" src={instagramIcon} height={"22"} width={"22"} style={{ display: "flex" }} />
            default:
                return <img alt="whatsApp" src={whatsappIcon} height={"22"} width={"22"} style={{ display: "flex" }} />
        }
    }

    // const onChangeOfSwitch = (list: workflowList) => {
    //     const updated_workflow_list = filteredWorkFlowList.map((cList: workflowList) => {
    //         if(cList.workflow_id === list.workflow_id){
    //             cList.flag_live = !cList.flag_live;
    //         } 
    //         return cList;
    //     }); 

    //     setFilteredWorkFlowList(updated_workflow_list);
    // }  

    const sortContactData = (key: keyof getChatbotListNewReponseModel, direction: string) => {
        if (filteredWorkFlowList) {
            const filtered_workflow_list = filteredWorkFlowList.sort((a: getChatbotListNewReponseModel, b: getChatbotListNewReponseModel) => {
                let aValue, bValue;
                aValue = a[key];
                bValue = b[key];
                if (aValue === "" && bValue === "") {
                    return 0;
                }
                if (aValue === "") {
                    return direction === 'ascending' ? -1 : 1;
                }
                if (bValue === "") {
                    return direction === 'ascending' ? 1 : -1;
                }
                if (aValue && bValue && aValue < bValue) {
                    return direction === 'ascending' ? -1 : 1;
                }
                if (aValue && bValue && aValue > bValue) {
                    return direction === 'ascending' ? 1 : -1;
                }
                return 0;
            })
        }
    }

    const sortData = (key: keyof getChatbotListNewReponseModel) => {
        setChangeField(key);
        let dir = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            dir = 'descending';
        }
        if (filteredWorkFlowList) {
            sortContactData(key, dir);
            setSortConfig({ key: key, direction: dir });
        }
    }

    return (
        <>
            <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", boxSizing: "border-box", maxHeight: `${innerHeight}px !important` }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle} sx={{ width: "40px" }}></TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle} sx={{ cursor: "pointer" }} onClick={() => { sortData("chatbot_name") }}>
                                <Grid container alignItems={"center"} flexWrap={"nowrap"} gap={"8px"} sx={{ width: "100% !important" }}>
                                    <Grid item>
                                        Chatbot Name
                                    </Grid>
                                    <Grid item>
                                        <Typography style={{ color: sortConfig.direction === "ascending" && "chatbot_name" === changeField ? "rgba(0,0,0,0.85)" : "rgba(0,0,0,0.1)", lineHeight: "normal", fontSize: "10px", cursor: "pointer", height: "12px" }}>▲</Typography>
                                        <Typography style={{ color: sortConfig.direction === "descending" && "chatbot_name" === changeField ? "rgba(0,0,0,0.85)" : "rgba(0,0,0,0.1)", lineHeight: "normal", fontSize: "10px", cursor: "pointer", height: "12px" }}>▼</Typography>
                                    </Grid>
                                </Grid>
                            </TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Chatbot Status</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Import Status</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Deployment Channel</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Trigger Keywords</TableCell>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${dashboardStyles.viewButtonColumnHeadingStyle}`}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredWorkFlowList?.map((list: getChatbotListNewReponseModel, ind: number) => {
                            return (
                                <TableRow
                                    onClick={() => {
                                        if (!isImportStatusImporting(list)) {
                                            navigate(`/workflow/staticWorkflowDetails?workflow_id=${list.chatbot_id}`);
                                        }
                                    }}
                                    key={ind}
                                    className={`${dashboardStyles.cellRow} ${isImportStatusImporting(list) ? dashboardStyles.nonClickableRow : ""}`}
                                >
                                    {/* Chatbot Name */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`} sx={{ width: "40px" }}>
                                        {handleIntegratedChannel(list.chatbot_channel.channel_name)}
                                    </TableCell>
                                    
                                    {/* Chatbot Name */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`}>
                                        <GlobalTooltip
                                            title={(isImportStatusImporting(list) || isImportStatusFailed(list)) ? getChatbotImportStatusName(list) : getChatbotStatusName(list)}
                                            arrow
                                            placement='top'
                                        >
                                            <span style={{ backgroundColor: handleDotColor(list) }} className={workflowStyle.wokflowTitleDot}></span>
                                        </GlobalTooltip>
                                        {list.chatbot_name}
                                    </TableCell>

                                    {/* Chatbot Status */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`}>
                                        {getChatbotStatusName(list)}
                                    </TableCell>

                                    {/* Import Status */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`}>
                                        <Grid container gap={"6px"} alignItems={"center"} flexWrap={"nowrap"}>
                                            <Grid item>
                                                {getChatbotImportStatusName(list)}
                                            </Grid>
                                            {isImportStatusFailed(list) &&
                                                <GlobalTooltip title={list?.import_failed_reason || "Import failed"} arrow placement='top'>
                                                    <Grid item className={globalStyles.displayFlexStyle}>
                                                        <IconsColor iconName="info" fillColor={primaryColor} height={"15"} width={"15"} />
                                                    </Grid>
                                                </GlobalTooltip>
                                            }
                                        </Grid>
                                    </TableCell>

                                    {/* Deployment Channel */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`}>
                                        <Grid container gap={"8px"} alignItems={"center"} flexWrap={"nowrap"}>
                                            <Grid item>
                                                {list.meta_integration_instagram_data
                                                    ? (list.meta_integration_instagram_data.instagram_account_name || "-")
                                                    : (list.meta_integration_whatsapp_phone_number_data?.[0]?.verified_name || "-")
                                                }
                                            </Grid>
                                            <Grid item>
                                                {list.meta_integration_instagram_data 
                                                    ? `| ${list.meta_integration_instagram_data.instagram_account_id}`
                                                    : list?.meta_integration_whatsapp_phone_number_data?.[0] 
                                                    ? `| ${list.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number}`
                                                    : ""
                                                }
                                            </Grid> 
                                            {(list?.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number || list?.meta_integration_instagram_data?.instagram_account_name) && 
                                                <Grid item>
                                                    <img 
                                                        alt="qr_image" 
                                                        src={QRimage} 
                                                        height={"22"} 
                                                        width={"22"} 
                                                        className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} 
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const isInstagram = !!list?.meta_integration_instagram_data;
                                                            onClickOfQRCode(
                                                                isInstagram
                                                                    ? (list.meta_integration_instagram_data?.instagram_account_name ?? "")
                                                                    : (list?.meta_integration_whatsapp_phone_number_data?.[0]?.display_phone_number ?? ""),
                                                                list?.chatbot_step_deployment_trigger_data?.[0]?.condition_group,
                                                                setFlagShowQRCodePopup,
                                                                setPhoneNumberQR,
                                                                setConditionGroup,
                                                                setQrChannelName,
                                                                isInstagram ? CHATBOT_CHANNEL_NAME.INSTAGRAM : CHATBOT_CHANNEL_NAME.WHATSAPP
                                                            );
                                                        }} 
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    </TableCell>

                                    {/* Trigger Keywords */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable}`}>
                                        <Grid item>
                                            <Grid container gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                                {list?.chatbot_step_deployment_trigger_data?.map((trigger) => {
                                                    return (
                                                        <>
                                                            {trigger?.condition_group ? 
                                                                <>
                                                                    {trigger?.condition_group?.condition_values?.map((value: string) => {
                                                                        return (
                                                                            <Grid item className={`${workFlowGlobalStyles.triggerKeywordChip}`}>
                                                                                <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>{value}</Typography>
                                                                            </Grid>
                                                                        );
                                                                    })}
                                                                </>
                                                             : 
                                                                <Grid item>
                                                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>Default</Typography>
                                                                </Grid>
                                                             }
                                                        </>
                                                    );
                                                })}
                                            </Grid>
                                        </Grid>
                                    </TableCell>

                                    {/* Actions */}
                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${globalStyles.clickable} ${dashboardStyles.viewButtonColumnStyle}`} sx={{ textAlign: "end" }} onClick={(e) => e.stopPropagation()}>
                                        <MoreVertIcon
                                            sx={{ cursor: "pointer" }}
                                            onClick={(e: any) => { e.stopPropagation(); handleMenuOpen(e, list.chatbot_id, list) }}
                                        />
                                        <Menu
                                            anchorEl={anchorEl}
                                            keepMounted
                                            open={Boolean(anchorEl) && list.chatbot_id === currentRowIndex}
                                            onClose={handleMenuClose}
                                        >
                                            {workflowActionMenuItem.map((item, index) => {
                                                return (
                                                    <MenuItem
                                                        className={globalStyles.menuItemStyle}
                                                        key={index}
                                                        sx={{ fontSize: "14px", fontWeight: "500" }}
                                                        onClick={(e) => { e.stopPropagation(); handleMenuClose(); item.action(list) }} 
                                                        disabled={item.isDisabled}
                                                    >
                                                        <ListItemIcon>
                                                            {item.icon}
                                                        </ListItemIcon>
                                                        <span>
                                                            {item.label}
                                                        </span>
                                                    </MenuItem>
                                                );
                                            })}
                                        </Menu>

                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default WorkflowTable
